import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type JobsBase from "@/pages/Jobs.Base.vue";

export default defineMosaicComponent<typeof JobsBase>("pages/Jobs");
